export enum PurchaseTypes {
    Subscription = 'subscription',
    Dropin = 'dropin',
    Appointment = 'appointment',
    Venues = 'venues'
}

export interface IStripeKeyResponse {
    data: {
        customerId: string,
        gateway: string,
    },
    success: boolean
}

export interface IGetOrderDetailsParams {
    optionId: number,
    couponCode?: string,
    returnUrl: string,
    customerStripeId: string
}

export interface IOrderDetailsResponse {
    success: boolean,
    data: IOrderDetails
}

export interface IOrderDetails {
    client_key: string,
    countryCode: string,
    couponId: number,
    currency: string,
    discount: number
    fee_transaction_fee: number,
    fee_transaction_fix: number,
    gateway: string
    invoice_vat: number
    paymentIntentId: string
    price: number
    stipePublicKey: string,
    totalfee: number,
    vat_amount: number
}